export const productDetailBeforeEnter = (to, next, enableNewProductCatalog) => {
  const { productId } = to.params
  const { legacy } = to.query
  if (enableNewProductCatalog && legacy !== 'true') {
    // redirect to new catalog page based on inventory
    next(`/product-catalog/inventory/${productId}`)
    return
  }
  next()
}
